import React from "react"

const EditIcon = ({ onEdit }): JSX.Element => (
  <span className="cursor-pointer" onClick={onEdit}>
    <i className="fas fa-edit" />
  </span>
)

export default EditIcon
